import React, { useState } from "react";

const SalesForce = ({
  connectionData,
  onSubmitFun,
  testConnectionSuccess,
  submissionSuccess,
}) => {
  const [connectionCreds, setConnectionCreds] = useState({
    sfdc_password: "",
    sfdc_security_token: "",
    sf_username: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setConnectionCreds((prevCreds) => ({
      ...prevCreds,
      [name]: value,
    }));
  };

  const handleSubmit = (isTestConnection) => {
    const formData = {
      ...connectionData,
      connectionCreds,
    };
    if (onSubmitFun) {
      onSubmitFun(formData, isTestConnection);
    }
  };

  return (
    <div>
      <div className="individualRow">
        <div className="inputHostName">
          <label htmlFor="sfdc_password">SFDC Password</label>
          <br />
          <input
            type="text"
            id="sfdc_password"
            name="sfdc_password"
            placeholder="Enter Host Name"
            value={connectionData.sfdc_password}
            onChange={handleChange}
          />
        </div>
        <div>
          <label htmlFor="sfdc_security_token">SFDC Security Token</label>
          <br />
          <input
            type="text"
            id="sfdc_security_token"
            name="sfdc_security_token"
            placeholder="Enter Port Name"
            onChange={handleChange}
            value={connectionData.portName}
          />
        </div>
      </div>
      <div className="individualRow">
        <div className="inputHostName">
          <label htmlFor="sf_username">SF Username*</label>
          <br />
          <input
            type="text"
            id="sf_username"
            name="sf_username"
            placeholder="Enter Host Name"
            value={connectionData.sf_username}
            onChange={handleChange}
          />
        </div>
      </div>

      <div className="individualRow" style={{ marginTop: "20px" }}>
        <button
          className="job-btn btn nar-wid"
          type="submit"
          // onSubmit={handleSubmit}
          onClick={() => handleSubmit(false)}
          // disabled={!testConnectionSuccess}
          // disabled={!testConnectionSuccess || submissionSuccess}
        >
          Submit
        </button>
        <button
          className="job-btn btn nar-wid"
          onClick={() => handleSubmit(true)}
          // disabled={!testConnectionSuccess}
          // disabled={!testConnectionSuccess || submissionSuccess}
        >
          Check Connection
        </button>
      </div>
    </div>
  );
};

export default SalesForce;
